/* Etiquetas multiidoma en castellano. */
export default {
  "bookingView.agencyReference": "Referencia agencia",
};
